
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/find",
      function () {
        return require("private-next-pages/password/find/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password/find"])
      });
    }
  